import { immerable } from "immer";
import { EditAndConcatCustomEdlSegment } from "./edit-and-concat-custom-edl-segment";

export class EditAndConcatCustomEdl {
  [immerable];
  segments: EditAndConcatCustomEdlSegment[] | null = [];
  segmentsCount: number | null = 0;

  constructor(init?: Partial<EditAndConcatCustomEdl>) {
    Object.assign(this, init);
  }
}
